import React, { useRef, useCallback } from "react";
import { Editor } from "@tinymce/tinymce-react";
import {
  tinymceConfigForBlog,
  tinymceConfigForJob,
} from "../utils/tinymceConfig";

interface TinyMCEEditorProps {
  initialValue?: string;
  onChange?: (content: string) => void;
  apiKey?: string;
  height?: number;
  placeholder?: string;
  disabled?: boolean;
  type: string;
}

const TinyMCEEditor: React.FC<TinyMCEEditorProps> = ({
  initialValue = "",
  onChange,
  apiKey,
  height = 400,
  placeholder = "",
  disabled = false,
  type,
}) => {
  const editorRef = useRef<any>(null);
  const tinymceConfig =
    type === "blog" ? tinymceConfigForBlog : tinymceConfigForJob;

  const handleEditorChange = useCallback(
    (content: string) => {
      if (onChange) {
        onChange(content);
      }
    },
    [onChange]
  );

  const handleEditorInit = useCallback((evt: any, editor: any) => {
    editorRef.current = editor;
  }, []);

  const config = {
    ...tinymceConfig,
    height,
    placeholder,
    setup: function (editor: any) {
      // Call the original setup if it exists
      if (tinymceConfig.setup && typeof tinymceConfig.setup === "function") {
        tinymceConfig.setup(editor);
      }

      // Add our custom setup
      editor.on("init", handleEditorInit);

      // Prevent content type errors
      editor.on("BeforeSetContent", function (e: any) {
        if (e.content && typeof e.content !== "string") {
          e.content = String(e.content);
        }
      });
    },
  };

  return (
    <Editor
      apiKey={apiKey}
      init={config}
      onEditorChange={handleEditorChange}
      initialValue={initialValue}
    />
  );
};

export default TinyMCEEditor;
